import { PlusCircleIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { SetAlertsCard } from './set-alerts-card/set-alerts-card'
import { useContent } from './use-content'

export interface ContentProps {
  isEoir?: boolean
  closeDialog: VoidFunction
}

export const Content = ({ isEoir = false, closeDialog }: ContentProps) => {
  const {
    alertSettingsDataList,
    isDisabledSetAlertButton,
    isDisabledSetAnotherAlertButton,
    isPendingUpsertCaseAlerts,
    updateAlertSettingsDataList,
    addAlertSettingsItem,
    deleteAlertSettingsItem,
    updateAlertSettingErrorList,
    handleClickSetAlertButton,
  } = useContent({ isEoir, closeDialog })

  return (
    <div className={cn('flex flex-col space-y-4')}>
      <p className={cn('text-sm font-medium')}>
        Notification alerts will be sent via email only once, at 12:00 PM EST, on the day the alert is configured.
      </p>

      {alertSettingsDataList.map((data, index) => (
        <SetAlertsCard
          key={`${data.id}`}
          defaultValues={data}
          onValueChange={(value) => updateAlertSettingsDataList(value, index)}
          onDeleteCard={() => deleteAlertSettingsItem(data.id)}
          onError={(errors) => updateAlertSettingErrorList(errors, index)}
        />
      ))}

      <Button
        type="button"
        variant="outline"
        className={cn('justify-between', 'h-[52px]')}
        disabled={isDisabledSetAnotherAlertButton}
        onClick={addAlertSettingsItem}
      >
        Add another alert
        <PlusCircleIcon size={24} />
      </Button>

      <Button
        type="button"
        variant="default"
        className={cn('w-fit')}
        loading={isPendingUpsertCaseAlerts}
        disabled={isDisabledSetAlertButton}
        onClick={handleClickSetAlertButton}
      >
        Set alert
      </Button>
    </div>
  )
}
